/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Members_Add_Success_InviteInputs */



/**
* | output |
* | --- |
* | "An invitation was sent to the new member's email!" |
*
* @param {Members_Add_Success_InviteInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const members_add_success_invite = /** @type {((inputs?: Members_Add_Success_InviteInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Members_Add_Success_InviteInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Eine Einladung wurde an die E-Mail des neuen Mitglieds gesendet!")
	return /** @type {LocalizedString} */ ("An invitation was sent to the new member's email!")
});